<div class="page-container">
    <div class="container">
        <div class="row">
            <div class="col-md-12 pt-5">
                <h2>
                    {{ 'central-login.account.settings.your.account' | translate }}
                </h2>
                <div class="row mt-5">
                    <div class="col-md-3">
                        <central-login-account-settings-navigation [page]="'personal-info'"></central-login-account-settings-navigation>
                    </div>
                    <div class="col-md-9" *ngIf="currentUser">
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="mt-0 mb-4">{{ 'central-login.account.settings.personal.info' | translate }}</h3>
                                <h4>{{ 'central-login.account.settings.personal.info.current.email' | translate }}</h4>
                                {{ 'central-login.account.settings.personal.info.your.current.email' | translate }} <span class="font-weight-bold">{{ currentUser.email }}</span>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <h4>{{ 'central-login.account.settings.personal.info.about.you' | translate }}</h4>
                                <form [formGroup]="nameForm" (ngSubmit)="saveName()">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="form-control-label"
                                                >{{ 'central-login.first.name.placeholder' | translate }}
                                                <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && _nameForm.firstName.errors }" />
                                            </label>
                                            <div *ngIf="submitted && _nameForm.firstName.errors">
                                                <div class="alert alert-danger mt-3 p-2" *ngIf="_nameForm.firstName.errors.required">{{ 'central-login.first.name.required' | translate }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="form-control-label"
                                                >{{ 'central-login.last.name.placeholder' | translate }}
                                                <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submitted && _nameForm.lastName.errors }" />
                                            </label>
                                            <div *ngIf="submitted && _nameForm.lastName.errors">
                                                <div class="alert alert-danger mt-3 p-2" *ngIf="_nameForm.lastName.errors.required">{{ 'central-login.last.name.required' | translate }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-6">
                                            <button type="submit" class="btn psd-variant w-100" [disabled]="submitting">{{ 'central-login.account.settings.personal.info.save' | translate }}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
